import { DEFAULT_EMPTY_VALUE } from '../constants';
import {
  RISK_CONSEQUENCES,
  RISK_LEVEL,
  RISK_LIKELIHOOD,
} from '../constants/risks';
import {
  convertIdToValue,
  convertValueToId,
  getValueFromConstantObject,
} from '../details';

/* LIKELIHOOD METHOD VALUES */
export const getRiskLikelihood = list => {
  return convertIdToValue({
    list,
    key: 'likelihood',
    constant: RISK_LIKELIHOOD,
    defaultValue: DEFAULT_EMPTY_VALUE,
  });
};

export const getRiskLikelihoodId = (value, defaultValue) => {
  return value
    ? getValueFromConstantObject({
        constant: RISK_LIKELIHOOD,
        value,
        key: 'id',
      })
    : defaultValue;
};

/* RISK CONSEQUENCES METHOD VALUES */
export const getRiskConsequenceId = (value, defaultValue) => {
  return value
    ? getValueFromConstantObject({
        constant: RISK_CONSEQUENCES,
        value,
        key: 'id',
      })
    : defaultValue;
};

export const getRiskConsequence = list => {
  return convertIdToValue({
    list,
    key: 'consequence',
    constant: RISK_CONSEQUENCES,
    defaultValue: DEFAULT_EMPTY_VALUE,
  });
};

/* RISK LEVEL METHOD VALUES */
export const getRiskLevelValue = list => {
  return convertIdToValue({
    list,
    key: 'rating',
    constant: RISK_LEVEL,
    defaultValue: DEFAULT_EMPTY_VALUE,
  });
};

export const getRiskLevelId = (value, defaultValue) => {
  return value
    ? getValueFromConstantObject({ constant: RISK_LEVEL, value, key: 'id' })
    : defaultValue;
};

export const getRiskLevelByValue = value => {
  return convertValueToId({ list: RISK_LEVEL, value });
};
